export { DMS_MODULE } from '../../constants';
export const NAME = 'MontazDV';
